module.exports = __webpack_public_path__ + "./bannerImg_02401951366647a11c88d97d9cd408ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/landingPage/bannerImg.jpg
// module id = 383
// module chunks = 0